import { fg } from '@atlassian/jira-feature-gating';

const fixDisabledVoting = {
	get(): boolean {
		return fg('jracloud-81233-fix-disabled-voting');
	},
};

export default fixDisabledVoting;
